import React from 'react';
import { Field, FieldInputProps, FieldRenderProps } from 'react-final-form';
import { observer } from 'mobx-react';

import AppStorage from 'Storage/Storage';
import DataForm from 'interfaces/PersonalDataForm';
import Labels from '../../enums/Labels';
import { TafSelectInput } from '@taf-ui/react';
import { translate } from '../../utils/utils';
import { Option, TafChangeEvent } from '@taf-ui/core';

const defaultProps = {
  label: '',
  placeholder: '',
  isRequired: true,
};
type DefaultProps = Readonly<typeof defaultProps>;

type Props = {
  fieldName: Extract<keyof DataForm, 'nationality' | 'country'>;
  label: Labels;
  placeholder: Labels;
  isRequired: boolean;
} & Partial<DefaultProps>;

class InputNationality extends React.PureComponent<Props> {
  private readonly storage: AppStorage;

  static defaultProps: DefaultProps = defaultProps;

  defaultOption: Option;

  constructor(props: Props) {
    super(props);

    this.storage = AppStorage.getInstance();
    this.defaultOption = { value: '', title: translate(props.placeholder, this.storage.getLocale) };
  }

  handleChange = (e: CustomEvent<TafChangeEvent<string>>, input: FieldInputProps<string>) => {
    input.onChange(e.detail.value);
  };

  render(): React.ReactElement {
    const {
      fieldName,
      label,
      isRequired,
    } = this.props;

    const options = [this.defaultOption, ...this.storage.getNationalitiesOptions];

    return (
      <Field name={fieldName}>
        {({ input, meta }: FieldRenderProps<string>): React.ReactElement => (
          <TafSelectInput
            label={translate(label, this.storage.getLocale)}
            value={input.value}
            name={fieldName}
            inputId={fieldName}
            onTafChange={(e) => this.handleChange(e, input)}
            onTafBlur={() => input.onBlur()}
            validationState={meta.error && meta.touched ? 'error' : undefined}
            validationMessage={translate(meta.error as Labels, this.storage.getLocale)}
            options={options}
            required={isRequired}
          />
        )}
      </Field>
    );
  }
}

export default observer(InputNationality);
